<template>
  <div class="auth">
    <div class="auth__header">
      <h2 class="auth__title">Вход в систему</h2>
      <span class="auth__line"></span>
    </div>
    <form class="auth__form form" @submit.prevent="SubmitForm">
      <div class="form__content">
        <CustomInput
          ref="login"
          type-input="text"
          label="Логин"
          placeholder="Введите Ваш логин"
          :inputId="'log'"
        >
        </CustomInput>

        <CustomInput
          ref="password"
          type-input="password"
          label="Пароль"
          placeholder="Введите Ваш пароль"
          inputId="pass"
        >
        </CustomInput>

        <div class="form__checkbox">
          <input
            v-model="inSistem"
            type="checkbox"
            @change="remainInSistem"
          />
          <span class="slider"></span>
          <span class="form__text">Оставаться в системе</span>
        </div>
      </div>
      <div class="form__footer" type="submit">
        <button class="form__footer-btn">
          <authIcon/>
          Войти
        </button>
      </div>
    </form>

  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import CustomInput from '@/components/ui/CustomInput.vue'
import authIcon from '@/components/icons/authIcon.vue'

export default {
  name: 'FormAuth',
  components: {
    CustomInput,
    authIcon
  },
  setup () {
    const store = useStore()

    const password = ref(null)
    const login = ref(null)
    const inSistem = computed(() => store.getters.getInSistem)

    const SubmitForm = () => {
      store.dispatch('setSignIn', {
        login: login.value.valueInput,
        password: password.value.valueInput
      })
    }

    const remainInSistem = () => {
      store.commit('SetInSistem', !inSistem.value)
    }

    return {
      SubmitForm,
      inSistem,
      password,
      login,
      remainInSistem
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  width: 551px;
  background-color: #FFFFFF;
  overflow: hidden;

  &__header {
    padding: 24px 24px 0 24px;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
  }

  &__line {
    display: block;
    flex: 1;
    height: 2px;
    background-color: #C8C8C8;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
  }
}

.form {
  display: flex;
  flex-direction: column;

  &__content {
    padding: 0 24px;
  }

  &__checkbox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    input {
      width: 20px;
      height: 20px;
      border: 2px solid #787878;
      border-radius: 5px;
    }
  }

  &__text {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 400;
  }

  &__footer {
    display: flex;
    justify-content: center;
    height: 90px;
    background-color: #F5F5F5;
    padding: 24px;
    border: 1px solid #C8C8C8;

    &-btn {
      width: 200px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 12px;
      font-size: 18px;
      font-weight: 400;
      color: #FFFFFF;
      background-color: #00ABEC;
      border-radius: 6px;

      @media(any-hover: hover) {
        &:hover {
          background: #0080B0;
          transition: 0.8s;
        }
      }

      &:active {
        background: #006084;
        transition: 0.5s;
      }
    }
  }
}
</style>
